/* eslint-disable no-nested-ternary */
/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
// import actions from '../actions';
import * as regExp from './regExp';
import { clearPhone, prepareNameForSave, toCamelCaseWithPrefix } from './string';

const DATE_ERROR = 'Неверный формат даты ("дд.мм.гггг")';
const MEDICAL_CARD_ERROR = 'Поле должно содержать 16 цифр';
const DATE_LESS_ERROR = 'Пожалуйста, проверьте дату';
const DATE_COMPARE_ERROR = 'Дата начала не может быть больше даты окончания';
const TIME_COMPARE_ERROR = 'Время начала не может быть больше времени окончания';
const TEXT_ERROR = 'Использованы запрещенные символы';
const CURRENCY_ERROR = 'Сумма не может быть отрицательной';
const USERNAME_ERROR = 'Минимум 5 символов';
const REQUIRED_ERROR = 'Обязательное поле';
const PHONE_ERROR = 'Введите корректный номер телефона';
const TIME_ERROR = 'Введите корректное время';
const NEW_PASSWORD_ERROR = 'Минимум 8 символов, по крайней мере одна буква, одна цифра, один спец символ';
const MIN_DATE = new Date(1900, 0, 1);
const PHONE_MIN_LENGTH = 9;
const ISO_DATE_REGEXP = /^(\d{4})-(\d{2})-(\d{2})$/;
const MASK_DATE_REGEXP = /^(\d{2})\.(\d{2})\.(\d{4})$/;

const createDateFromParts = (year, month, day) => {
    const date = new Date(year, month - 1, day);

    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
        ? date
        : null;
};

export const parseFormDate = (value) => {
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    if (typeof value !== 'string') {
        return null;
    }

    const trimmedValue = value.trim();
    const isoMatch = ISO_DATE_REGEXP.exec(trimmedValue);
    if (isoMatch) {
        const [ , year, month, day ] = isoMatch;
        return createDateFromParts(Number(year), Number(month), Number(day));
    }

    const maskMatch = MASK_DATE_REGEXP.exec(trimmedValue);
    if (maskMatch) {
        const [ , day, month, year ] = maskMatch;
        return createDateFromParts(Number(year), Number(month), Number(day));
    }

    return null;
};

// export const resetValues = (formName, targetFields, initData) => {
//     const fields = { ...targetFields };
//     if (Object.hasData(targetFields)) {
//         Object.keys(targetFields).map(field => {
//             fields[field].value = initData ? initData[field] : '';
//             const error = getErrorMessage(fields[field]);
//             fields[field].isValid = !error;
//             fields[field].error = undefined;
//         });
//     }
//     return actions.updateFormWithFormNameData(formName, { fields });
// };

// TODO: rename func and give poss not to pass fileds (get all values from passed fields)
export const getDataForForm = (fields, targetData) => {
    const data = {};
    const needFields = fields || targetData;

    if (Object.keys(needFields)
        .some(el => targetData[el] === undefined)) {
        return null;
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const key in needFields) {
        if (targetData[key].type === 'text') {
            data[key] = String(targetData[key].value)
                .trim();
        } else {
            data[key] = targetData[key].value;
        }
    }
    return data;
};

export const getSimpleDataForm = (fields) => {
    const data = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const key in fields) {
        if (fields[key].type === 'text') {
            data[key] = String(fields[key].value)
                .trim();
            if (key === 'firstName' || key === 'lastName' || key === 'middleName') {
                data[key] = prepareNameForSave(data[key]);
            }
        } else if (fields[key].type === 'phone') {
            const phoneCleared = clearPhone(fields[key].value);
            data[key] = regExp.belarusianClearPhone.test(phoneCleared) ? phoneCleared : fields[key].value;
        } else {
            data[key] = fields[key].value;
        }
    }
    return data;
};

const all = (xs, fn) => !!Object.keys(xs)
    .reduce((acc, x) => {
        return acc && fn(xs[x]);
    }, true);

export const allValid = fields => all(fields, field => field.isValid === true);

export const VALIDATORS = {
    date: v => (v && new Date(v) ? null : DATE_ERROR),
    text: v => (regExp.text.test(v) ? null : TEXT_ERROR),
    email: v => (regExp.email.test(v) ? null : TEXT_ERROR),
    fio: v => (regExp.fio.test(v) ? null : TEXT_ERROR),
    fioOrDash: v => (regExp.fioOrDash.test(v) ? null : TEXT_ERROR),
    phone: (v) => {
        if (!v || v === '') {
            return null;
        }

        const clearedPhone = clearPhone(v);

        if (regExp.startWithBelarusianPrefix.test(v)) {
            return clearedPhone.length >= 12 && regExp.belarusianPhone.test(v)
                ? null
                : PHONE_ERROR;
        }

        return regExp.text.test(v) && clearedPhone.length >= PHONE_MIN_LENGTH
            ? null
            : PHONE_ERROR;
    },
    shortPhone: v => (regExp.shortPhone.test(v) ? null : PHONE_ERROR),
    date_less: (v) => {
        if (
            v === null ||
            v === undefined ||
            v === '' ||
            (typeof v === 'string' && v.trim() === '') ||
            (typeof v === 'string' && /^[_.\s]+$/.test(v))
        ) {
            return null;
        }

        const date = parseFormDate(v);
        const now = new Date();

        if (!date) {
            return DATE_LESS_ERROR;
        }

        if (date > now || date < MIN_DATE) {
            return DATE_LESS_ERROR;
        }

        const year = date.getFullYear();
        const currentYear = now.getFullYear();
        if (year < 1900 || year > currentYear) {
            return DATE_LESS_ERROR;
        }

        return null;
    },
    date_start_or_date_compare: v => (v[0] && v[1] ? VALIDATORS.date_compare(v) : VALIDATORS.date(v[0]) ? [VALIDATORS.date(v[0])] : null),
    date_compare_or_empty: v => (!v[0] && !v[1] ? null : VALIDATORS.date_compare(v)),
    date_compare: v => (VALIDATORS.date(v[0]) || VALIDATORS.date(v[1])
        ? [ VALIDATORS.date(v[0]), VALIDATORS.date(v[1]) ]
        : new Date(v[0]) <= new Date(v[1])
            ? null
            : [DATE_COMPARE_ERROR]),
    time_compare: v => (VALIDATORS.time(v[0]) || VALIDATORS.time(v[1])
        ? [ VALIDATORS.time(v[0]), VALIDATORS.time(v[1]) ]
        : v[0] <= v[1]
            ? null
            : [TIME_COMPARE_ERROR]),
    number: v => (regExp.number.test(v) ? null : TEXT_ERROR),
    medicalCardId: v => (regExp.medicalCardId.test(v) ? null : MEDICAL_CARD_ERROR),
    checkbox: v => (typeof v === 'boolean' ? null : TEXT_ERROR),
    time: v => (regExp.time.test(v) ? null : TIME_ERROR),
    timeWithSecondsAliquotFive: v => (regExp.timeWithSecondsAliquotFive.test(v) ? null : TIME_ERROR),
    radio: v => (v ? null : REQUIRED_ERROR),
    newPassword: v => (regExp.newPassword.test(v) ? null : NEW_PASSWORD_ERROR),
    username: v => (regExp.username.test(v) ? null : USERNAME_ERROR),
    currency: v => (Number(String(v)
        .replace(/[^0-9.-]/g, '')) > 0 ? null : CURRENCY_ERROR),
    objectHasData: v => (Object.hasData(v) ? null : REQUIRED_ERROR),
};

export const validateByFieldType = (type, value) => {
    if (!value) {
        return null;
    }
    const validator = VALIDATORS[type];

    if (!validator) {
        return null;
    }
    return validator(value);
};

export const validateByFieldRequired = (required, value, messageRequiredError) => {
    if (!required) {
        return null;
    }

    const isEmpty = !value ||
        (typeof value === 'string' && value.trim() === '') ||
        (typeof value === 'string' && /^[_.\s]+$/.test(value));

    return isEmpty ? (messageRequiredError || REQUIRED_ERROR) : null;
};

export const getErrorMessage = ({
    required,
    validationType,
    value,
    messageRequiredError,
}) => {
    const requiredValid = validateByFieldRequired(required, value, messageRequiredError);
    const valueValid = validateByFieldType(validationType, value);
    return requiredValid || valueValid;
};

// export const setAllErrors = async fields => {
//     const errorFields = {};
//     for (const field in fields) {
//         if (!fields[field].isValid) {
//             const error = getErrorMessage(fields[field]);
//             errorFields[field] = { ...fields[field], error, isValid: !error };
//         }
//     }
//
//     if (Object.hasData(errorFields)) {
//         const newFields = {
//             ...fields,
//             ...errorFields,
//         };
//         await actions.updateFormData({ fields: newFields, isFormValid: false });
//         const element = document.querySelector('.input_error');
//         element.scrollIntoView({
//             block: 'center',
//             behavior: 'smooth',
//         });
//     }
// };

const getFieldsWithError = (fields) => {
    const errorFields = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const field in fields) {
        if (!fields[field].isValid) {
            const error = fields[field].error || getErrorMessage(fields[field]);
            errorFields[field] = {
                ...fields[field],
                error,
                isValid: !error,
            };
        }
    }
    return errorFields;
};

const updateFormAndScrollToError = (fields, errorFields, formName) => {
    // eslint-disable-next-line no-undef
    const element = document.querySelector('.input_error');
    element &&
    element.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
    });
    return {
        formName,
        data: { fields: { ...fields, ...errorFields } },
    };
};

// eslint-disable-next-line consistent-return
export const setAllErrorsInFormNamed = (formData, formName) => {
    const {
        fields,
        isFormValid,
    } = formData[formName];
    if (!isFormValid) {
        const errorFields = getFieldsWithError(fields);
        return updateFormAndScrollToError(fields, errorFields, formName);
    }
};

export const setErrorsInForm = async (fields, formName) => {
    const errorFields = getFieldsWithError(fields);
    await updateFormAndScrollToError(fields, errorFields, formName);
};

/**
 * Transforms array into hash object.
 * @param {*} list source array
 * @param {*} idKey id key
 * @param {*} valKey value key
 */
export const arrayToHash = (list, idKey = 'id', valKey) => {
    const r = {};
    if (list) {
        const isKeyFn = typeof idKey === 'string' ? e => e[idKey] : idKey;
        list.forEach((e) => {
            r[isKeyFn(e)] = valKey ? e[valKey] : e;
        });
    }
    return r;
};

export const checkAllFormValid = (formData) => {
    return Object.keys(formData)
        .every(key => (Object.hasData(formData[key].fields) ? formData[key].isFormValid : true));
};

export const getFieldsWithPrefixId = (fields, prefix) => Object.keys(fields)
    .reduce((acc, field) => {
        const fieldName = toCamelCaseWithPrefix(prefix, field);
        return {
            ...acc,
            [field]: {
                ...fields[field],
                id: fieldName,
            },
        };
    }, {});
